import CommonError from '../Common/CommonError'
import { error403 } from '../ErrorSvg'

const Error403Container = () => {
  return (
    <CommonError src={error403} />
  )
}

export default Error403Container